import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Flex, ActivityIndicator, RichText, SidebarPageContent, PageHeading, useStaticState } from '@phishtool/ui';
import { knowledgeBaseArticleService } from '../../service';
const KnowledgeBaseArticle = ({ contentId }) => {
    const [staticData] = useStaticState();
    const { siteStructure = [] } = staticData || {};
    const { data, isLoading } = knowledgeBaseArticleService.hooks.useGetKnowledgeBaseArticle(contentId);
    return isLoading ? (_jsx(Flex, Object.assign({ width: "100%", height: "100%", align: "center", justify: "center" }, { children: _jsx(ActivityIndicator, { size: 50 }) }))) : (_jsxs(SidebarPageContent, { children: [_jsx(PageHeading, { level: 1, spacer: "xxxl", siteStructure: siteStructure }), _jsx(RichText, { data: data })] }));
};
export default KnowledgeBaseArticle;
